import EntityListCard from '@repo/ui/components/cards/EntityListCard';
import { useState } from 'react';
import {
  ProgramGoal,
  useCreateProgramGoal,
  useDeleteProgramGoal,
  useProgramGoals,
  useUpdateProgramGoal,
} from '../hooks/program-goals';
import Button from '@repo/ui/components/Button';
import Input from '@repo/ui/components/Input';

export default function ProgramGoalsEntityCard() {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const { data, isLoading } = useProgramGoals({
    searchQuery,
    page: currentPage,
  });

  return (
    <EntityListCard
      isLoading={isLoading}
      title="Program Goals"
      onSearchQueryChange={setSearchQuery}
      items={data?.programGoals ?? []}
      itemToEntityItem={item => ({
        key: item.programgoalid,
        title: item.programdesc,
        onClick: () => {},
      })}
      onPageChange={setCurrentPage}
      currentPage={currentPage}
      totalPages={data?.totalPages}
      AddOrUpdateItemFormComponent={AddOrUpdateProgramGoalForm}
    />
  );
}

function AddOrUpdateProgramGoalForm({
  item,
  onCreate,
  onUpdate,
  onDelete,
}: {
  item?: ProgramGoal;
  onCreate: () => void;
  onUpdate: () => void;
  onDelete: () => void;
}) {
  const { mutate: createProgramGoal } = useCreateProgramGoal({
    onSuccess: onCreate,
  });

  const { mutate: updateProgramGoal } = useUpdateProgramGoal({
    onSuccess: onUpdate,
  });

  const { mutate: deleteProgramGoal } = useDeleteProgramGoal({
    onSuccess: onDelete,
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = Object.fromEntries(formData.entries());
    if (item) {
      updateProgramGoal({
        ...item,
        ...data,
      } as ProgramGoal);
    } else {
      createProgramGoal(data as ProgramGoal);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4">
      <Input isTextarea label="Description" name="programdesc" defaultValue={item?.programdesc} />
      <div className="space-x-4">
        <Button>{item ? 'Update Program Goal' : 'Add Program Goal'}</Button>
        {item && (
          <button
            onClick={() => deleteProgramGoal(item.programgoalid)}
            type="button"
            className="rounded-md border border-red-500 px-4 py-2 text-sm text-red-500"
          >
            Delete Program Goal
          </button>
        )}
      </div>
    </form>
  );
}
